import { v4 as uuidv4 } from 'uuid'

const STORAGE_KEY = 'idempotentKey'

export const idempotent = {
  get : () => {
    return sessionStorage.getItem(STORAGE_KEY)
  },

  refresh : () => {
    sessionStorage.setItem(STORAGE_KEY, uuidv4())
  },

  clear : () => {
    sessionStorage.removeItem(STORAGE_KEY)
  },

  has : () => {
    return sessionStorage.getItem(STORAGE_KEY) !== null
  }
}
